module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
        test: /\.(m)?js$/,
        exclude: /node_modules/,
        loader: FURTHER_REF + 'babel-loader',
        options: {
        plugins: [
            // FURTHER_REF + "babel-plugin-transform-async-to-generator",
            FURTHER_REF + "babel-plugin-transform-decorators-legacy",
            FURTHER_REF + "babel-plugin-transform-react-jsx",
            FURTHER_REF + 'babel-plugin-transform-es2015-classes',
            FURTHER_REF + 'babel-plugin-add-module-exports',
            FURTHER_REF + 'babel-plugin-transform-es2015-modules-umd',
            FURTHER_REF + 'babel-plugin-transform-runtime',
            FURTHER_REF + 'babel-plugin-syntax-dynamic-import',
        ],
        presets: [
            FURTHER_REF + "babel-preset-preact",
            [
                // this preset makes our bundler a little smaller
                FURTHER_REF + "babel-preset-env", {
                    "targets": {
                    "browsers": ["last 2 versions" /*, "safari >= 7" */]
                    },
                    useBuiltIns: true,
                    modules: false,
                    // loose: true
                }
            ]
        ],
        // presets: [
        //   [
        //     FURTHER_REF + 'babel-preset-es2015',
        //     { modules: false, loose: true, }
        //   ]
        // ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/technologies/js.js